import { render, staticRenderFns } from "./SED-expand.vue?vue&type=template&id=4e88720c&scoped=true"
import script from "./SED-expand.vue?vue&type=script&lang=js"
export * from "./SED-expand.vue?vue&type=script&lang=js"
import style0 from "./SED-expand.vue?vue&type=style&index=0&id=4e88720c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88720c",
  null
  
)

export default component.exports